import { Component, type ReactNode } from 'react';

/** A failed route download must leave an accessible recovery action. */
export class RouteLoadBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override render() {
    if (this.state.failed)
      return (
        <main>
          <h1>Page unavailable</h1>
          <p role="alert">This page could not be loaded. Reload to try again.</p>
          <button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload page
          </button>
        </main>
      );
    return this.props.children;
  }
}
